/* Shoppable lookbook hotspots.

   One delegated listener for the whole document, so hotspots added by the theme
   editor work without rebinding, and multiple lookbook sections on one page
   share a single handler. */
(function () {
  'use strict';

  /* This file is emitted per section, so a page with two lookbooks would run it
     twice and register two listeners - every tap would then open and instantly
     close the card. Same guard as nische-wishlist.js. */
  if (window.NischeLookbook) return;

  var OPEN = 'is-open';

  function cardOf(spot) {
    return spot.querySelector('[data-nlb-card]');
  }

  function close(spot) {
    if (!spot || !spot.classList.contains(OPEN)) return;
    var card = cardOf(spot);
    var dot = spot.querySelector('[data-nlb-dot]');
    spot.classList.remove(OPEN);
    if (card) {
      card.hidden = true;
      card.classList.remove('is-below', 'is-start', 'is-end');
    }
    if (dot) dot.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('[data-nlb-spot].' + OPEN).forEach(function (s) {
      if (s !== except) close(s);
    });
  }

  /* Show the card, then measure it against the stage and flip it inward if it
     would be clipped. Measuring has to happen while it is visible, which is why
     the classes are applied after unhiding rather than guessed up front. */
  function open(spot) {
    var card = cardOf(spot);
    var dot = spot.querySelector('[data-nlb-dot]');
    var stage = spot.closest('[data-nlb-stage]');
    if (!card) return;

    closeAll(spot);
    spot.classList.add(OPEN);
    card.hidden = false;
    if (dot) dot.setAttribute('aria-expanded', 'true');
    if (!stage) return;

    var s = stage.getBoundingClientRect();
    var c = card.getBoundingClientRect();

    if (c.top < s.top + 4) card.classList.add('is-below');

    if (c.left < s.left + 4) {
      card.classList.add('is-start');
    } else if (c.right > s.right - 4) {
      card.classList.add('is-end');
    }
  }

  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target || !target.closest) return;

    var closer = target.closest('[data-nlb-close]');
    if (closer) {
      evt.preventDefault();
      close(closer.closest('[data-nlb-spot]'));
      return;
    }

    var dot = target.closest('[data-nlb-dot]');
    if (dot) {
      evt.preventDefault();
      var spot = dot.closest('[data-nlb-spot]');
      spot.classList.contains(OPEN) ? close(spot) : open(spot);
      return;
    }

    /* A click anywhere else closes any open card - but not a click inside one,
       which would swallow the link to the product. */
    if (!target.closest('[data-nlb-card]')) closeAll();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var open_ = document.querySelector('[data-nlb-spot].' + OPEN);
    if (!open_) return;
    var dot = open_.querySelector('[data-nlb-dot]');
    close(open_);
    if (dot) dot.focus();
  });

  /* The theme editor re-renders a section on every settings change, which drops
     any open card. Nothing to restore, but neighbouring sections keep working. */
  document.addEventListener('shopify:section:load', function () {
    closeAll();
  });

  window.NischeLookbook = { close: closeAll };
})();
